module.exports = __webpack_public_path__ + "img/bid-failure.69a91b92.png";